import React from "react";
import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const steps = [
  { num: "01", title: "Strategy", desc: "Positioning, pricing, and market clarity" },
  { num: "02", title: "Demand Creation", desc: "Targeted outreach that attracts the right buyers" },
  { num: "03", title: "Lead Management", desc: "Structured pipeline with disciplined follow-ups" },
  { num: "04", title: "Channel Ecosystem", desc: "Aligned brokers and partners are driving deal flow" },
  { num: "05", title: "Sales Conversion", desc: "Guided conversations, negotiation, and closure control" },
  { num: "06", title: "Tracking & Optimization", desc: "Real-time visibility and continuous performance improvement" },
];

const ComprehensiveServices = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        position: "relative",
        py: 12,
        overflow: "hidden",

        // 💎 LUXURY BLUE BG
        background: `
          linear-gradient(
            135deg,
            #0f63a5 0%,
            #0c4f85 60%,
            #083a63 100%
          )
        `,
      }}
    >
      {/* 🔥 GLOSS LIGHT */}
      <Box
        sx={{
          position: "absolute",
          top: "-30%",
          left: "-10%",
          width: "700px",
          height: "700px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.25), transparent 60%)",
          filter: "blur(80px)",
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2, px: { xs: 2, md: 8 } }}>

        {/* HEADER */}
        <Box sx={{ textAlign: "center", mb: 10 }}>
          <Box
            sx={{
              width: 70,
              height: 3,
              background: "rgba(255,255,255,0.7)",
              margin: "0 auto 20px",
              borderRadius: "10px",
            }}
          />

          <Typography
            variant="h4"
            sx={{

              fontSize: { xs: 32, md: 46 },
              color: "#ffffff",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Sales Ecosystem Model
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.85)",
              fontSize: 16,
            }}
          >
            A structured system designed to turn demand into controlled, predictable revenue
          </Typography>
        </Box>

        {/* FLOW */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.3,
          }}
        >
          {steps.map((step, index) => (
            <React.Fragment key={index}>

              {/* 💎 GLOSSY CARD */}
              <Box
                sx={{
                  width: isMobile ? "70%" : 220,
                  maxWidth: isMobile ? 340 : "none",
                  height: isMobile ? "auto" : 180,
                  borderRadius: "26px",
                  p: 1.5,
                  position: "relative",
                  overflow: "hidden",

                  background: `
                    linear-gradient(
                      160deg,
                      rgba(255,255,255,0.15),
                      rgba(255,255,255,0.05)
                    )
                  `,
                  backdropFilter: "blur(14px)",
                  border: "1px solid rgba(255,255,255,0.25)",

                  boxShadow: `
                    0 10px 30px rgba(0,0,0,0.25),
                    0 25px 60px rgba(0,0,0,0.3)
                  `,
                }}
              >
                <Box sx={{ position: "relative", zIndex: 2, textAlign: "start" }}>

                  {/* NUMBER */}
                  <Typography
                    sx={{
                      color: "#ffffff",
                      fontSize: 14,
                      fontWeight: 700,
                      mb: 1,
                      fontFamily: '"Playfair Display", serif !important',
                    }}
                  >
                    {step.num}
                  </Typography>

                  {/* 💎 TITLE FIX (IMPORTANT) */}
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: '"Playfair Display", serif !important',

                      // fontSize: 18,
                      color: "#fff",

                      minHeight: { xs: "auto", md: "42px" }, // ✅ KEY FIX (align descriptions)
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                  >
                    <b>{step.title}</b>
                  </Typography>

                  {/* 💎 DESCRIPTION (NOW ALIGNED) */}
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: 14,
                      color: "rgba(255,255,255,0.85)",
                      mt: 1,
                    }}
                  >
                    {step.desc}
                  </Typography>
                </Box>
              </Box>

              {/* 🔥 ARROWS */}
              {index !== steps.length - 1 && (
                isMobile ? (
                  <ArrowDownwardIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: 30,
                      my: 1,
                    }}
                  />
                ) : (
                  <ArrowForwardIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: 30,
                      filter: "drop-shadow(0 0 8px rgba(255,255,255,0.6))",
                    }}
                  />
                )
              )}

            </React.Fragment>
          ))}
        </Box>

      </Container>
    </Box>
  );
};

export default ComprehensiveServices;